import type { ClientConfig } from '@ferro/config';
import { applyBrandKit } from '@ferro/core/branding';

/**
 * Apply brand styling driven entirely by the client config.
 *
 * Delegates to the canonical `applyBrandKit` helper in `@ferro/core/branding`
 * so the admin-app and customer-app share exactly one source of truth for
 * the mapping from `ClientConfig.brand` to CSS custom properties (base
 * `--brand-*` + Tailwind v4 `--color-brand-*`). admin-app does not use
 * Tailwind today, but consuming the shared helper means the moment it
 * picks up any `bg-brand-*` utility the tokens are already correct — no
 * silent ALA bleed.
 *
 * Imported via the `/branding` subpath specifically — the package's main
 * entry pulls in server-only code (Prisma, Express) that would bloat the
 * admin-app bundle.
 *
 * The admin tab title gets the ` · Admin` suffix so staff can tell which
 * surface they're on (`Happy Tail Happy Dog · Admin` vs the customer-app's
 * bare `Happy Tail Happy Dog`).
 *
 * w0.2 RUNTIME OVERRIDE: the `config` passed in is no longer always the
 * static `clients/<slug>/config.ts` baseline. `main.tsx` calls
 * `loadTenantBrand` first, which fetches `GET /api/tenants/:slug/brand`
 * and overlays the DB-backed `TenantBranding` row on top of the static
 * `config.brand`. Static config remains the fallback when the request
 * fails or times out.
 *
 * Idempotent — calling twice is a no-op.
 */
export function installBrandStyles(config: ClientConfig): void {
  applyBrandKit(config, { titleSuffix: ' · Admin' });
}
